import { useEffect } from "react";
import { createCookie } from "utils/functions";

/**
 * Custom hook for handling UTM parameters
 * Extracts UTM data from URL search params and creates a cookie
 * Extracts Coupon code from url search params and creates a cookie
 */
export const useUtm = () => {
	useEffect(() => {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const couponName = urlSearchParams.get("coupon");

		const utmParams = {
			utm_source: urlSearchParams.get("utm_source"),
			utm_pathname: urlSearchParams.get("utm_pathname"),
			utm_referrer: urlSearchParams.get("utm_referrer"),
			utm_medium: urlSearchParams.get("utm_medium"),
			utm_campaign: urlSearchParams.get("utm_campaign"),
			utm_content: urlSearchParams.get("utm_content"),
			utm_term: urlSearchParams.get("utm_term"),
		};

		const utmData = Object.fromEntries(
			Object.entries(utmParams).filter(([, value]) => value != null)
		);

		if (Object.keys(utmData).length > 0) {
			createCookie(
				"UTM",
				JSON.stringify(utmData),
				true,
				30 * 24 * 60 * 60 * 1000, // 30 days
				"/",
				true,
				true
			);
		}

		if (couponName) {
			createCookie(
				"coupon_name",
				couponName,
				true,
				1 * 60 * 60 * 1000, // 1 hours
				"/",
				true,
				true
			);
		}
	}, []);

	return null;
};

export default useUtm;
